module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-17caf8042810251267570ee62707e030.png";